import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'bst-export-dialog',
    templateUrl: './export-dialog.component.html',
    styleUrls: ['./export-dialog.component.scss'],
    standalone: false
})
export class ExportDialogComponent implements OnInit {

  // Set through the dialog context; the trip overview (#1514) offers PDF and CSV.
  @Input() title = 'tracking.export';
  @Input() formats = ['xlsx', 'csv'];
  // The trip overview spans at most a year, like the server enforces.
  @Input() maxYear = false;
  public labels = {xlsx: 'Excel (.xlsx)', csv: 'CSV (.csv)', pdf: 'PDF (.pdf)'};
  public form: FormGroup;
  // Moments, not Dates: the app's datepicker runs on NbMomentDateModule and cannot show a Date.
  public today = moment().endOf('day');

  constructor(
    protected ref: NbDialogRef<ExportDialogComponent>,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      start: [moment().startOf('month'), Validators.required],
      end: [moment().startOf('day'), Validators.required],
      format: ['xlsx', Validators.required]
    }, {validators: g => this.maxYear && g.value.start && g.value.end
        && moment(g.value.end).isSameOrAfter(moment(g.value.start).add(1, 'year'), 'day') ? {range: true} : null});
  }

  ngOnInit() {
    this.form.patchValue({format: this.formats[0]});
  }

  cancel() {
    this.ref.close(null);
  }

  submit() {
    if (this.form.valid) {
      this.ref.close(this.form.value);
    }
  }
}